import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { TokenProviderService, LoginResponse } from 'src/app/api';
import { map, startWith, tap } from 'rxjs/operators';
import {
  irParaConsoleDeConta,
  isKeycloakSession,
} from '../../angularjs-app/services/auth/keycloak/keycloak.util';
import { AuthService } from '../services/ajs-auth.service';
import { UiRouterState } from '../services/ajs-router-state.service';
import { RouterTransitionsService } from '../services/ajs-router-transitions.service';
import { PerfilService } from '../services/ajs-perfil.service';

@Component({
  selector: 'mandae-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarComponent implements OnInit {
  public navLinks = [];
  private _currentUser: LoginResponse = null;

  public get currentUser() {
    return this._currentUser;
  }

  public set currentUser(value: LoginResponse) {
    this._currentUser = value;
    this.changeDetectorRef.markForCheck();
  }

  // Senha e verificação em duas etapas ficam no Keycloak; a sessão do login legado não tem conta lá.
  public get keycloakSession() {
    return isKeycloakSession();
  }

  constructor(
    private tokenProviderService: TokenProviderService,
    private changeDetectorRef: ChangeDetectorRef,
    private auth: AuthService,
    private state: UiRouterState,
    private transitions: RouterTransitionsService,
    private perfilService: PerfilService
  ) {}

  ngOnInit() {
    this.transitions.onSuccess({}, async (transition) => {
      const state = transition.to().$$state();

      const data: any =
        state.data && state.data.headerMenuItems
          ? await this.podeExibirLinks(state.data.headerMenuItems)
          : [];

      this.navLinks = (state.data && data && data.slice()) || [];

      const activeIndex = this.navLinks.findIndex(
        (link) => link.state === state.name
      );
      if (activeIndex >= 0) {
        this.navLinks[activeIndex] = {
          ...this.navLinks[activeIndex],
          active: true,
        };
      }
      this.changeDetectorRef.markForCheck();
    });

    this.tokenProviderService.user
      .pipe(
        startWith(this.tokenProviderService.currentUser),
        tap((user) => (this.currentUser = user))
      )
      .subscribe();
  }

  public async logout() {
    const eventos = {
      eventoMixpanel: 'Menu',
    };

    try {
      await this.auth.logout(eventos);

      if (typeof window !== 'undefined') {
        window.location.href = '/login';
      }
    } catch (err) {}
  }

  public gotoState(state: string) {
    return this.state.go(state, {}, { inherit: false });
  }

  public gotoProfile() {
    return this.gotoState('minha-conta');
  }

  public openAccountSecurity() {
    irParaConsoleDeConta();
  }

  public async podeExibirLinks(state): Promise<any> {
    const data = (await this.perfilService.getBetaFeatures()).funcionalidades;

    return state.map((navegacao) => {
      navegacao.visible = true;

      const verifica = data.filter((item) => item.codigo === navegacao.state);

      if (verifica.length) {
        navegacao.visible = verifica[0].possuiAcesso;
      }

      return navegacao;
    });
  }
}
